import type { NumberInputValue } from '@vtex/admin-ui'
import { Button, csx, NumberInput } from '@vtex/admin-ui'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl'

import { useOrderForm } from '../../../../core/requests/checkout'
import { CheckoutRoute } from '../../../Checkout/constants'

type SelectedSku =
  | {
      _id: string
      id: string
    }
  | undefined

export type AddToCartSectionProps = {
  selectedSku: SelectedSku
}

export const AddToCartSection = ({ selectedSku }: AddToCartSectionProps) => {
  const { addItemToCartLegacy } = useOrderForm()
  const history = useHistory()
  const [quantity, setQuantity] = useState(1)

  const handleQuantityChange = (newQuantity: NumberInputValue) => {
    setQuantity(+newQuantity)
  }

  const handleAddToCartClick = () => {
    if (!selectedSku) {
      return
    }

    // TODO: implement force take away, needs stock data
    // TODO: unavailable item
    addItemToCartLegacy({
      quantity,
      id: selectedSku._id,
    })

    history.push(CheckoutRoute.Cart)
  }

  return (
    <div
      className={csx({
        display: 'grid',
        gap: '$space-3',
        gridTemplateRows: '1fr',
        '@tablet': {
          gridTemplateColumns: '152px 1fr',
        },
      })}
    >
      <NumberInput
        value={1}
        min={1}
        max={999}
        onChange={handleQuantityChange}
      />
      <Button
        size="large"
        onClick={handleAddToCartClick}
        disabled={!selectedSku}
      >
        <FormattedMessage id="add-to-cart" />
      </Button>
    </div>
  )
}
